module.exports = __webpack_public_path__ + "img/DK31467012.9eb84ca7.png";